import PropTypes from 'prop-types';
import KTTooltip, { KTTooltipPositions } from '../KTTooltip';

export const KTLabelType = {
  default: '',
  rounded: 'label-rounded',
  square: 'label-square',
};

export const KTLabelSize = {
  default: '',
  small: 'label-sm',
  medium: 'label-md',
  large: 'label-lg',
  extraLarge: 'label-xl',
};

KTLabel.propTypes = {
  text: PropTypes.string,
  type: PropTypes.oneOf(Object.values(KTLabelType)),
  isInline: PropTypes.bool,
  isPill: PropTypes.bool,
  isDotStyle: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(KTLabelSize)),
  additionalClassName: PropTypes.string,
  color: PropTypes.string,
  customBgColor: PropTypes.string,
  customTitleColor: PropTypes.string,
  additionalDescription: PropTypes.string,
  tooltipPlacement: PropTypes.oneOf(Object.values(KTTooltipPositions)),
  tooltipOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
};

function KTLabel({
  text = '',
  type = KTLabelType.default,
  isInline = true,
  isPill = true,
  isDotStyle = false,
  size = KTLabelSize.default,
  additionalClassName = '',
  color,
  customBgColor,
  customTitleColor,
  style,
  additionalDescription = '',
  tooltipPlacement = KTTooltipPositions.topEnd,
  tooltipOffset = [0, 8],
}) {
  return (
    <div>
      <KTTooltip
        text={additionalDescription}
        textHeader=""
        isHtmlContent
        position={tooltipPlacement}
        offset={tooltipOffset}
      >
        <span
          className={`
          label 
          ${type}
          ${isInline ? 'label-inline' : ''}
          ${isPill ? 'label-pill' : ''}
          ${isDotStyle ? 'label-dot' : ''}
          ${size}
          ${additionalClassName}
          ${additionalDescription ? 'text-underline' : ''}
        `}
          style={{
            backgroundColor: color ?? customBgColor ?? '',
            fontWeight: '600',
            color: customTitleColor,
            textDecoration: additionalDescription ? 'underline' : undefined,
            ...style,
          }}
        >
          {text}
        </span>
      </KTTooltip>
    </div>
  );
}

export default KTLabel;
